import { apiConfig } from "./apiConfig";

const getTodayPostUrl = apiConfig.oftheday.today;

export const getTodayPosts = (axios) => axios.get(`${getTodayPostUrl}`);
